import makeStyles from "utils/makeStyles";

export default makeStyles((theme) => ({
  passwordIcon:{
    "& :hover": {
      cursor:"pointer"
    }
  },
  visibility: {
    color: "#848484",
  },
}));